/** Public routes for footer navigation (work from any marketing page). */
export const FOOTER_ROUTES = {
  features: '/features',
  about: '/about',
  careers: '/careers',
  blog: '/blog',
  press: '/blog',
  help: '/help',
  contact: '/contact',
  status: '/status',
  community: '/community',
  cookies: '/cookies',
  gdpr: '/gdpr',
  api: '/developers',
  integrations: '/integrations',
};
